export function getIzdatnice(izdatnice) {
    return { type: 'GET_IZDATNICE', izdatnice };
}